import { render, staticRenderFns } from "./icon-location.vue?vue&type=template&id=618a8b97"
import script from "./icon-location.vue?vue&type=script&lang=ts"
export * from "./icon-location.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports